(function () {
   'use strict';

   var logger = new (require('../helpers/logger.js'))("AssetCoreHelper").setColor("rgb(214, 106, 37)").setDebug(true);
   var helper = require('../helpers/generic.js');
   var settings = require('../helpers/settings.js');
   var ACImage = require('./mediaImage.js');
   var ACAudio = require('./mediaAudio.js');
   var ACVideo = require('./mediaVideo.js');

   module.exports = {
      getCode: function getCode(codeOrUrlWithCode){
        if (codeOrUrlWithCode.startsWith('http') && codeOrUrlWithCode.includes("celemony") && codeOrUrlWithCode.includes("/code/")){ //legacy; is full assetcore url containing code
          var legacyUrl = codeOrUrlWithCode;
          codeOrUrlWithCode = legacyUrl.replace( this.getCodeRegex(), "$1" );
          logger.deprecation("resolved code '"+codeOrUrlWithCode+"' via legacy url '"+legacyUrl+"'! Note that you should only pass the code, not the whole url!");
        }
        return codeOrUrlWithCode;
      },
      fromDetailJson: function fromDetailJson(detailJson){
         if (helper.undefOrNull(detailJson)){
           throw "Could not instantiate AssetCoreMedia. Detail-JSON was " + detailJson;
         }
         if (detailJson.type == "image"){
           return new ACImage(detailJson);
         } else if (detailJson.type == "video" || detailJson.type == "smartmovie"){
           return new ACVideo(detailJson);
         } else if (detailJson.type == "audio"){
           return new ACAudio(detailJson);
         } else {
           throw "unsupported media type '"+detailJson.type+"'";
         }
       },
      getCodeRegex: function getCodeRegex(){
        return /^https?:\/\/.*\/code\/([\w\-\.]*)((\?|\&).*)?/g;
      },
      generateMediaData: function generateMediaData(type, quality, provider, url){
        var acMediaData = {
          type: type,
          code: "none",
          languages: {}
        };
        acMediaData.languages[ settings.currentLanguage() ] = {
          defaultQuality: quality,
          qualities: {}
        };
        acMediaData.languages[ settings.currentLanguage() ].qualities[ quality ] = {
          provider: provider,
          detail: {
            url: url
          }
        };
        return acMediaData;
      }
  };



}());



//////////////////
// WEBPACK FOOTER
// ./src/AssetCore/helper.js
// module id = 7
// module chunks = 0